import {
  Button, Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  makeStyles, MenuItem, Select,
  Slide, Switch,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import {TransitionProps} from '@material-ui/core/transitions/transition';
import React, {useEffect, useRef, useState} from 'react';
import * as yup from 'yup';
import {Formik, FormikProps} from 'formik';
import Loading from "../../UiComponents/Loading";
import {CheckBox} from "@material-ui/icons";
import OperatorSettings from "../../../Domain/Models/OperatorSettings";
import {operatorRepository} from "../../../Domain/Repositories/OperatorRepository";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  form: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  dialog: {
    alignItems: 'flex-start',
  },
  deleteFlex: {
    flex: 1,
  }
}));

export interface OperatorSettingsModalProps
{
  open: boolean;
  onClose: () => void;
}

export default function OperatorSettingsModal(props: OperatorSettingsModalProps)
{
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const {open, onClose} = props;
  const classes = useStyles();

  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string>();

  const formRef = useRef<FormikProps<OperatorSettings>>(null);

  const schema = yup.object().shape({
    password: yup.string().required('Required')
  });

  const handleSubmit = (value: OperatorSettings) =>
  {
    setSubmitting(true);
    setSubmitError(undefined);

    operatorRepository.updateSettings(value)
        .then(() => onClose())
        .catch((e: Error) =>
        {
          setSubmitting(false);
          setSubmitError(e.message);
        });
  }

  useEffect(() =>
  {
    if (open)
    {
      setSubmitError(undefined);
      setSubmitting(false);
    }
  }, [open]);

  return (
      <Dialog
          classes={{scrollPaper: classes.dialog}}
          open={open}
          onClose={onClose}
          fullScreen={fullScreen}
          fullWidth
          maxWidth="md"
          disableEscapeKeyDown
          disableBackdropClick={submitting}
          TransitionComponent={Transition}
      >
        <DialogTitle>OperatorSettings</DialogTitle>

        <Loading isLoading={submitting}>
          <DialogContent>
            <Formik<OperatorSettings>
                initialValues={{ password: "" }}
                onSubmit={(value) => handleSubmit(value)}
                validationSchema={schema}
                innerRef={formRef}
            >
              {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur
                }) => (
                  <>
                    <FormControl fullWidth margin="normal" error={touched.password && errors.password !== undefined}>
                      <InputLabel htmlFor="component-error">Password</InputLabel>
                      <Input
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}/>
                      <FormHelperText>{touched.password && errors.password}</FormHelperText>
                    </FormControl>
                  </>
              )}
            </Formik>

            {submitError != undefined && (
                <Typography component="h3" variant="subtitle1" color="error" gutterBottom>
                  {submitError}
                </Typography>
            )}
          </DialogContent>

          <DialogActions>
            <Button
                onClick={onClose} color="primary"
            >
              Cancel
            </Button>
            <Button
                onClick={() => formRef.current?.handleSubmit()}
                color="primary"
            >
              Submit
            </Button>
          </DialogActions>

        </Loading>
      </Dialog>
  );
}